import { render, staticRenderFns } from "./MaterialsCalculator.vue?vue&type=template&id=cffa23c2&"
import script from "./MaterialsCalculator.vue?vue&type=script&lang=js&"
export * from "./MaterialsCalculator.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsCalculator.vue?vue&type=style&index=0&id=cffa23c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports